import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import Modal from "@/components/modal/Modal";
import { literals } from "@/constants/literals";

interface ConfirmCreateReceptionProps {
  continueCapture: () => void;
  closeModal: () => void;
  message: string;
}

const ConfirmcreateReception = ({
  continueCapture,
  closeModal,
  message,
}: ConfirmCreateReceptionProps) => {
  return (
    <Modal
      title={literals.usedData}
      opened={message !== ""}
      onClose={closeModal}
    >
      <p className="mb-8 text-ib-pt-main text-ib-pt-color-gray-1000">
        {message}
      </p>
      <div className="mb-4">
        <PrimaryButton
          colour="red"
          label={literals.continue}
          onClick={continueCapture}
          size="medium"
        />
      </div>
      <div>
        <SecondaryButton
          colour="red"
          label={literals.cancel}
          onClick={closeModal}
          size="medium"
        />
      </div>
    </Modal>
  );
};

export default ConfirmcreateReception;
